import React from 'react';
import {Container, Row, Col} from "react-bootstrap";
import {Link} from 'gatsby';


function Readybuild(props) {
    return (
        <section className="p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="GCP Optimize">
                            <h2>Unleash Your True Potential With Our Google Cloud Consulting Services</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p> Choosing Google Cloud over other cloud providers gives you the opportunity to leverage the
                            power of one of the most advanced internet ecosystems. As a certified Google Cloud partner,
                            TekRevol can help you easily scale your business and optimize your organizational
                            workflow.</p>
                        <p>The Google ecosystem is an innovation-driven suite of incredible tools and platforms
                            progressing swiftly with the use of AI and machine learning. TekRevol can help you build
                            your application architecture or migrate your existing data architecture to Google Cloud.
                            Get in touch for a quick discovery call with our cloud consultants to get detailed
                            insights.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Readybuild;